import React, { useContext, useState } from "react";
import styles from "./HeaderIntroText.module.scss";
import Stats from "./Stats"

const HeaderIntroText = () => {
  return (
    <>
      <div className={`${styles.headerText} section`}>
        <p>
          Your game might be over, but the fun doesn't have to stop <br /> there. Relive your best throws, victorious celebrations and group photos below!
        </p>
      <Stats />
      </div>
    </>
  );
};

export default HeaderIntroText;
